import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Muestreador } from './entity-muestreador.model';

@Injectable({
  providedIn: 'root'
})
export class MuestreadorService {
  url: string;
  token: string;
  endpoint = 'muestreadores';

  constructor(private http: HttpClient) {}

  getMuestreador(): Observable<Muestreador[]> {
    return this.http.get<Muestreador[]>(`${this.url}/${this.endpoint}/`, {
      params: { token: this.token }
    });
  }

  addMuestreador(muestreador: Muestreador): Observable<Muestreador> {
    return this.http.post<Muestreador>(`${this.url}/${this.endpoint}/`, {
      ...muestreador
    });
  }

  changeMuestreador(p: Muestreador): Observable<Muestreador> {
    return this.http.patch<Muestreador>(
      `${this.url}/${this.endpoint}/${p.id}`,
      {
        muestreador: p,
        token: this.token
      }
    );
  }

  deleteMuestreador(p: Muestreador): Observable<Muestreador> {
    return this.http.delete<Muestreador>(
      `${this.url}/${this.endpoint}/${p.id}`,
      {
        params: { token: this.token }
      }
    );
  }
}
